import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/src/app/error.tsx");
